export const DEFAULT_HOURS_PER_DAY = 8
export const MAX_HOURS_PER_DAY = 24

export function isValidHoursPerDay(value) {
    return typeof value === "number" && Number.isFinite(value) && value > 0 && value <= MAX_HOURS_PER_DAY
}

export function getHoursPerDayOrDefault(value) {
    if (isValidHoursPerDay(value)) return value
    return DEFAULT_HOURS_PER_DAY
}
